import { Service } from '../service.model';

export class ServiceResult {
  public documentKey: string;
  public service: Service;
  constructor() {}
}
